import React from "react";
import mapfreLogo from "src/assets/icons/mapfre_logo.png";
import Summary from "./Summary";

const Header: React.FC = () => {
  return (
    <header
      className={`mb-6 flex max-w-360 flex-col justify-center gap-8 px-4 text-center lg:px-0`}
    >
      <nav
        className={`lg:border-secondary-4 flex grow items-center justify-center px-4 py-3 md:justify-start lg:border-b`}
      >
        <article className="flex items-center justify-start gap-8">
          <img src={mapfreLogo} alt="Pay2b" className="max-h-10 w-auto" />
        </article>
      </nav>
      <Summary />
    </header>
  );
};

export default Header;
